import { Spacer } from '@components/Spacer'
import { findIconDefinition, FontAwesomeIcon } from '@purposity/icons'
import { analytics } from '@services/Analytics'
import * as Colors from '@themes/Colors'
import { appConfig } from 'config'
import * as React from 'react'
import { Platform, Text, View } from 'react-native'
import { SolitoImage } from 'solito/image'
import { Link } from 'solito/link'
import { DollarTag } from '../DollarTag'
import { LocationTag } from '../LocationTag'
import { cardStyles, itemStyles, NeedCardViewPropsBase, styles } from './shared'

interface Props extends NeedCardViewPropsBase {
  organizationImagePath: string
  urgent?: boolean
}

export function LiveNeedCardView(props: Props) {
  const organizationImage =
    Platform.OS === 'web'
      ? new URL(props.organizationImagePath, appConfig.cdnURL).href
      : props.organizationImagePath

  const { style: viewPropsStyle, ...viewProps } = props.containerProps ?? {}

  const handleClick = async (e: React.MouseEvent) => {
    analytics.track('Need Click', {
      needId: props.id,
      needTitle: props.title,
      isUrgent: props.urgent ?? false,
      liveNeed: true,
    })
  }

  return (
    <Link
      href={{
        pathname: '/need/[needId]',
        query: { needId: props.id },
      }}
      as={`/need/${props.id}`}
      viewProps={{
        ...viewProps,
        style: [styles.containerBase, styles.containerLive, viewPropsStyle],
        onClick: handleClick,
      }}
    >
      <View role="article">
        <View style={cardStyles.header} role="banner">
          <View style={itemStyles.orgImageWrapper}>
            <SolitoImage
              src={organizationImage}
              width={24}
              height={24}
              quality={100}
              contentFit="cover"
              loading="lazy"
              alt=""
            />
          </View>
          <Spacer width={8} />
          <View
            style={{
              flex: 1,
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Text style={itemStyles.orgName} numberOfLines={1}>
              {props.organizationName}
            </Text>
            {props.urgent && (
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  backgroundColor: '#613EEA',
                  borderRadius: 16,
                  paddingVertical: 4,
                  paddingHorizontal: 8,
                  marginLeft: 8,
                }}
              >
                <FontAwesomeIcon
                  icon={findIconDefinition({
                    prefix: 'fas',
                    iconName: 'clock',
                  })}
                  color={Colors.white}
                  size={12}
                />
                <Spacer width={4} />
                <Text
                  style={{
                    color: Colors.white,
                    fontWeight: 'bold',
                    fontSize: 12,
                  }}
                >
                  urgent
                </Text>
              </View>
            )}
          </View>
        </View>
        <View style={cardStyles.body}>
          <Text
            accessibilityRole="header"
            numberOfLines={1}
            style={[itemStyles.needTitle, { flex: 1 }]}
          >
            {props.title}
          </Text>
          <Spacer height={8} />
          <Text style={itemStyles.needDescription}>
            {props.shortDescription}
          </Text>
        </View>
        <View style={cardStyles.footer} role="contentinfo">
          <DollarTag value={props.priceIncludingTip} />
          <LocationTag city={props.city} state={props.state} />
        </View>
      </View>
    </Link>
  )
}
